import { render, staticRenderFns } from "./addType.vue?vue&type=template&id=9448c04e&scoped=true&"
import script from "./addType.vue?vue&type=script&lang=js&"
export * from "./addType.vue?vue&type=script&lang=js&"
import style0 from "./addType.vue?vue&type=style&index=0&id=9448c04e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9448c04e",
  null
  
)

export default component.exports